import * as Yup from "yup";
import { BoletagemTipoGarantia } from "../boletagem";

export class BoletagemGarantiaSchema {
  public static updateForm() {
    const {
      tipoGarantia,
      tipoGarantiaOutro,
      prazoDeposito,
      valorGarantia,
      vigencia,
      cobertura,
      garantiaExecutada,
      obsGarantia,
    } = recordShape;

    const updateFormShape = {
      tipoGarantia,
      tipoGarantiaOutro,
      prazoDeposito,
      valorGarantia,
      vigencia,
      cobertura,
      garantiaExecutada,
      obsGarantia,
    };

    return Yup
      .object()
      .shape(updateFormShape);
  }
}

const recordShape = {
  garantia: Yup.boolean().required("Campo obrigatório"),
  tipoGarantia: Yup
    .mixed<BoletagemTipoGarantia>()
    .oneOf(Object.values(BoletagemTipoGarantia), `Tipo de garantia deve ser "${Object.values(BoletagemTipoGarantia).join('" ou "')}"`)
    .required("Campo obrigatório"),
  tipoGarantiaOutro: Yup
    .mixed()
    .when("tipoGarantia", {
      is: (tipoGarantia: BoletagemTipoGarantia) => tipoGarantia === BoletagemTipoGarantia.Outros,
      then: Yup
        .string()
        .nullable()
        .required("Campo obrigatório"),
      otherwise: Yup.string().nullable(),
    }),
  prazoDeposito: Yup.string().nullable(),
  valorGarantia: Yup.number().nullable(),
  vigencia: Yup.string().nullable(),
  cobertura: Yup
    .number()
    .nullable()
    .integer(),
  garantiaExecutada: Yup.boolean().nullable(),
  obsGarantia: Yup.string().nullable(),
};
